import { Suspense, lazy } from "react";
// components
import LoadingScreen from "../components/loading-screen";

const Loadable = (Component) => (props) =>
(
  <Suspense fallback={<LoadingScreen width="100px" height="100px" />}>
    <Component {...props} />
  </Suspense>
);

// AUTH
export const LoginPage = Loadable(
  lazy(() => import("../pages/auth/LoginPage"))
);

// DASHBOARD: GENERAL
export const GeneralAppPage = Loadable(
  lazy(() => import("../pages/dashboard/GeneralAppPage"))
);

// DASHBOARD: STOCK

export const AllStockListPage = Loadable(
  lazy(() => import("../pages/dashboard/IMS/AllStockListPage"))
);
export const AddStockPage = Loadable(
  lazy(() => import("../pages/dashboard/IMS/stocks/AddStockPage"))
);
export const AllStockEditPage = Loadable(
  lazy(() => import("../pages/dashboard/IMS/stocks/AllStockEditPage"))
);

export const LiveStockListPage = Loadable(
  lazy(() => import("../pages/dashboard/IMS/stocks/LiveStockListPage"))
);

export const AllAdjustmentListPage = Loadable(
  lazy(() => import("../pages/dashboard/IMS/adjustments/AllAdjustmentListPage"))
);

export const AddAdjustmentPage = Loadable(
  lazy(() => import("../pages/dashboard/IMS/adjustments/AddAdjustmentPage"))
);

export const AdjustmentEditPage = Loadable(
  lazy(() => import("../pages/dashboard/IMS/adjustments/AdjustmentEditPage"))
);

export const AllPurchaseOrderListPage = Loadable(
  lazy(() =>
    import("../pages/dashboard/IMS/purchaseOrder/AllPurchaseOrderListPage")
  )
);

export const AddPurchaseOrderPage = Loadable(
  lazy(() =>
    import("../pages/dashboard/IMS/purchaseOrder/AddPurchaseOrderPage")
  )
);

export const PurchaseOrderEditPage = Loadable(
  lazy(() =>
    import("../pages/dashboard/IMS/purchaseOrder/PurchaseOrderEditPage")
  )
);

export const StockTransferListPage = Loadable(
  lazy(() =>
    import("../pages/dashboard/IMS/stockTransfer/StockTransferListPage")
  )
);

export const StockTransferCreatePage = Loadable(
  lazy(() =>
    import("../pages/dashboard/IMS/stockTransfer/StockTransferCreatePage")
  )
);

export const StockTransferEditPage = Loadable(
  lazy(() =>
    import("../pages/dashboard/IMS/stockTransfer/StockTransferEditPage")
  )
);

//DASHBAORD: INGREDIENT

export const IngredientListPage = Loadable(
  lazy(() => import("../pages/dashboard/IMS/ingredients/IngredientListPage"))
);

export const IngredientCreatePage = Loadable(
  lazy(() => import("../pages/dashboard/IMS/ingredients/IngredientCreatePage"))
);

export const IngredientEditPage = Loadable(
  lazy(() => import("../pages/dashboard/IMS/ingredients/IngredientEditPage"))
);

//DASHBOARD: INVOICE

export const InvoiceListPage = Loadable(
  lazy(() => import("../pages/dashboard/IMS/invoice/InvoiceListPage"))
);

// DASHBOARD: REPORT
export const GeneralReportPage = Loadable(
  lazy(() => import("../pages/dashboard/GeneralReportPage"))
);

// DASHBOARD: Desigination
export const DesiginationCreatePage = Loadable(
  lazy(() => import("../pages/dashboard/DesiginationCreatePage"))
);
export const DesiginationEditPage = Loadable(
  lazy(() => import("../pages/dashboard/DesiginationEditPage"))
);

// DASHBOARD: SETTINGS
export const SettingsCreatePage = Loadable(
  lazy(() => import("../pages/dashboard/SettingsCreatePage"))
);

// DASHBOARD: USER
export const UserListPage = Loadable(
  lazy(() => import("../pages/dashboard/UserListPage"))
);
export const UserAccountPage = Loadable(
  lazy(() => import("../pages/dashboard/UserAccountPage"))
);
export const UserCreatePage = Loadable(
  lazy(() => import("../pages/dashboard/UserCreatePage"))
);
export const UserEditPage = Loadable(
  lazy(() => import("../pages/dashboard/UserEditPage"))
);

// MAIN
export const Page500 = Loadable(lazy(() => import("../pages/Page500")));
export const Page403 = Loadable(lazy(() => import("../pages/Page403")));
export const Page404 = Loadable(lazy(() => import("../pages/Page404")));


// Supplier
export const SupplierListPage = Loadable(
  lazy(() => import("../pages/dashboard/SupplierListPage"))
);
export const SupplierCreatePage = Loadable(
  lazy(() => import("../pages/dashboard/SupplierCreatePage"))
);
export const SupplierEditPage = Loadable(
  lazy(() => import("../pages/dashboard/SupplierEditPage"))
);
